import { atom, useAtom } from 'jotai';

const SubAccountCreateDialogAtom = atom<string>('');

export const useSubAccountCreateDialog = () => {
  const [idSubAccountCreateDialogOpen, setSubAccountCreateDialogOpen] = useAtom(
    SubAccountCreateDialogAtom
  );

  return {
    idSubAccountCreateDialogOpen,
    setSubAccountCreateDialogOpen,
  };
};
